import React from 'react';
import { Link } from 'react-router-dom';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddSubscriptionButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="raised"
    component={Link}
    to={`/subscriptions/create/?account_id=${record.id}`}
    label="Agregar suscripciones"
    title="Agregar suscripciones"
  >
    <ChatBubbleIcon />
  </Button>
);

export default withStyles(styles)(AddSubscriptionButton);
